// extracted by mini-css-extract-plugin
export default {"column__header":"column__header--psnHS","columnHeader":"column__header--psnHS","column__body":"column__body--xr1eW","columnBody":"column__body--xr1eW"};